module.exports = __webpack_public_path__ + "static/media/J7.5ae1aed5.jpg";